import { LoadableRoute } from 'routes/utils/loadable';

export const BullhornAuthModal = LoadableRoute({
  loader: () =>
    import(
      /* webpackChunkName: "IntegrationBullhornAuthModal" */ './BullhornAuthModal'
    ),
});
